import React, { useContext, useEffect } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import {
	IModificationsModalContext,
	ModificationsModalContext,
} from '../modificationsModalState/modificationsModalContext';
import { IUpdateDishV2 } from 'types';
import { updateDishV2 } from 'backend/dishes';
import { preventDefaultForEnterKey } from 'utils/helpers';
import { convertUndefinedFields } from 'utils/helpers';
import { Form } from 'antd';
import { ModalContent } from 'components/ModalWindows/ModalContent';
import { ModificationsDishesField } from './ModificationsDishesField';

interface IProps {
	onCloseModal: () => void;
	onFailureEvent?: () => void;
	onShowError: () => void;
}

export const EditForm: React.FC<IProps> = ({ onCloseModal, onFailureEvent, onShowError }) => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const {
		setModificationsDishCategory,
		setModificationsDishSubCategory,
		setFetchedModificationsDishes,
		setModificationsDishes,
		removeModificationsDish,
		dishInfo,
		IDsSelectedRestaurant,
		selectedModificationsDishCategory,
		selectedModificationsDishSubCategory,
		fetchedModificationsDishes,
		selectedModificationsDishes,
	} = useContext<IModificationsModalContext>(ModificationsModalContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			selectedModificationsDishCategory,
			selectedModificationsDishSubCategory,
			selectedModificationsDishes,
		});
	}, [selectedModificationsDishCategory, selectedModificationsDishSubCategory, selectedModificationsDishes]);

	const handleAssignRestaurants = async () => {
		if (dishInfo) {
			try {
				const dataForSubmit: IUpdateDishV2 = {
					id: dishInfo.id,
					fileId: '',
					name: dishInfo.name,
					description: dishInfo.description,
					articleNumber: dishInfo.articleNumber,
					externalId: dishInfo.externalId,
					translations: dishInfo.translations,
					overrideScheduleAvailability: dishInfo.overrideScheduleAvailability,
					activationCron: dishInfo.activationCron,
					deactivationCron: dishInfo.deactivationCron,
					restaurantIds: IDsSelectedRestaurant,
					suggestedDishIds: dishInfo.suggestedDishes.map((suggestedDish) => suggestedDish.id),
					additionalDishIds: dishInfo.additionalDishes.map((additionalDish) => additionalDish.id),
					dishModificationIds: selectedModificationsDishes,
				};
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateDishV2(convertedData);
				onCloseModal();
			} catch (err) {
				onShowError();
			} finally {
				hideLoader();
			}
		}
	};

	return (
		<ModalContent
			onConsentEvent={handleAssignRestaurants}
			onFailureEvent={onFailureEvent ? onFailureEvent : onCloseModal}
			heading="editModificationsList"
			headerTranslationNameSpace="form"
			translationOfConfirmBtn="saveButton"
			headingAlignment="left"
			centered={false}
			width="60%"
			isDisabledSave={!dishInfo}>
			<Form form={form} name="basic" onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<ModificationsDishesField
					setFetchedModificationsDishes={setFetchedModificationsDishes}
					setModificationsDishCategory={setModificationsDishCategory}
					setModificationsDishSubCategory={setModificationsDishSubCategory}
					setModificationsDishes={setModificationsDishes}
					removeModificationsDish={removeModificationsDish}
					IDsSelectedRestaurant={IDsSelectedRestaurant}
					selectedModificationsDishCategory={selectedModificationsDishCategory}
					selectedModificationsDishSubCategory={selectedModificationsDishSubCategory}
					selectedModificationsDishes={selectedModificationsDishes}
					fetchedModificationsDishes={fetchedModificationsDishes}
				/>
			</Form>
		</ModalContent>
	);
};
